export const notfound = {
  "notfound.title": "Page Not Found",
  "notfound.subtitle": "The page you're looking for doesn't exist or has been moved"
};

export default notfound;